var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card',{staticClass:"comparison-card",attrs:{"title":("Daily totals of suspicious traffic seen coming from " + (_vm.getNameByType(
        'asn'
      )) + " compared to " + (_vm.getNameByType(_vm.comparedWith)))}},[_c('ComparisonChart',{attrs:{"comparedWith":_vm.comparedWith}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }